module.exports = __webpack_public_path__ + "static/media/background-restaurant-hero.b18a9ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-restaurant-hero.jpg
// module id = 1587
// module chunks = 0